export default __webpack_public_path__ + "static/media/(9).a353e0cb.jpg";